import { Icon } from '@/components/ui';
import { cn } from '@/utils/cn';

import { useFieldContext } from './contexts';

type Props = {
  id?: string;
  accept?: string;
  placeholder?: string;
};

const firstError = (errors: unknown[]) => errors.find((e) => e !== undefined)?.toString();

export function FileInput({
  id = 'file-input',
  accept,
  placeholder = 'Click to select a file',
}: Props) {
  const field = useFieldContext<File | null>();
  const file = field.state.value;
  const errMsg = firstError(field.state.meta.errors);

  return (
    <label htmlFor={id} className={cn('ds-file-drop', errMsg && 'error')}>
      <input
        id={id}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={(e) => {
          field.handleChange(e.target.files?.[0] ?? null);
          field.handleBlur();
        }}
      />
      <Icon name="upload" size={26} style={{ color: errMsg ? 'var(--red)' : 'var(--text-3)' }} />
      {file ? (
        <div style={{ color: 'var(--brand)', fontWeight: 500 }}>
          {file.name} <span style={{ color: 'var(--text-3)', fontWeight: 400 }}>({(file.size / 1024).toFixed(2)} KB)</span>
        </div>
      ) : (
        <div>{placeholder}</div>
      )}
      {errMsg && <div className="ds-field-error">{errMsg}</div>}
    </label>
  );
}
